// The sticky bar settings are kept in this browser only, so reading them must survive blocked storage.
// A sticky bar is a bar with Bootstrap's .sticky-top.
const BARS = {
  navigation: { selector: "body > nav.navbar-dark", storageKey: "stickyNavigation" },
  breadcrumbs: { selector: "body > .local-header", storageKey: "stickyBreadcrumbs" },
};

export const isSticky = (name) => {
  try {
    return localStorage.getItem(BARS[name].storageKey) === "true";
  } catch (error) {
    return false;
  }
};

export const applyStickySettings = (body) => {
  Object.entries(BARS).forEach(([name, { selector }]) => {
    const bar = body.querySelector(selector);
    if (bar) bar.classList.toggle("sticky-top", isSticky(name));
  });
};

export const setSticky = (name, enabled) => {
  try {
    localStorage.setItem(BARS[name].storageKey, enabled);
  } catch (error) {
    // Storage is blocked: the setting then lasts for this page only.
  }
  applyStickySettings(document.body);
};
